const OPEN_REJECT_LAB_ORDER_MODAL = "OPEN_REJECT_LAB_ORDER_MODAL";
const OPEN_ACCEPT_LAB_ORDER_MODAL = "OPEN_ACCEPT_LAB_ORDER_MODAL";
const OPEN_SHOW_PRESCRIPTION_MODAL = "OPEN_SHOW_PRESCRIPTION_MODAL";
const OPEN_LAB_ORDER_SAMPLING_MODAL = "OPEN_LAB_ORDER_SAMPLING_MODAL";
const OPEN_HOME_CARE_ORDER_SAMPLING_MODAL = "OPEN_HOME_CARE_ORDER_SAMPLING_MODAL";
const OPEN_LAB_ORDER_GENERAL_RESULT_MODAL = "OPEN_LAB_ORDER_GENERAL_RESULT_MODAL";
const OPEN_LAB_ORDER_DIRECT_RESULT_MODAL = "OPEN_LAB_ORDER_DIRECT_RESULT_MODAL";
const OPEN_LAB_ORDER_LINK_RESULT_MODAL = "OPEN_LAB_ORDER_LINK_RESULT_MODAL";
const OPEN_LAB_ORDER_FILE_RESULT_MODAL = "OPEN_LAB_ORDER_FILE_RESULT_MODAL";
const OPEN_LAB_ORDER_FINISH_MODAL = "OPEN_LAB_ORDER_FINISH_MODAL";
const OPEN_LAB_ORDER_SAFE_CALL_MODAL = "OPEN_LAB_ORDER_SAFE_CALL_MODAL";
const OPEN_PHARMACY_ORDER_READY_MODAL = "OPEN_PHARMACY_ORDER_READY_MODAL";
const OPEN_PHARMACY_ORDER_REJECT_MODAL = "OPEN_PHARMACY_ORDER_REJECT_MODAL";
const OPEN_PHARMACY_ORDER_ACCEPT_MODAL = "OPEN_PHARMACY_ORDER_ACCEPT_MODAL";
const OPEN_PHARMACY_ORDER_PARTIAL_MODAL = "OPEN_PHARMACY_ORDER_PARTIAL_MODAL";
const OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL = "OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL";

function openRejectLabOrderModal(order) {
    return {
        type : OPEN_REJECT_LAB_ORDER_MODAL,
        open : true,
        order: order
    }
}

function closeRejectLabOrderModal() {
    return {
        type : OPEN_REJECT_LAB_ORDER_MODAL,
        open : false,
        order: {
            prescriptions: [],
            products: []
        }
    }
}

function openAcceptLabOrderModal(order) {
    return {
        type : OPEN_ACCEPT_LAB_ORDER_MODAL,
        open : true,
        order: order
    }
}

function closeAcceptLabOrderModal() {
    return {
        type : OPEN_ACCEPT_LAB_ORDER_MODAL,
        open : false,
        order: {
            prescriptions: [],
            products: []
        }
    }
}

function openPrescriptionModal(url) {
    return {
        type : OPEN_SHOW_PRESCRIPTION_MODAL,
        open : true,
        url: url
    }
}

function closePrescriptionModal() {
    return {
        type : OPEN_SHOW_PRESCRIPTION_MODAL,
        open : false,
        url: ""
    }
}

function openLabOrderSamplingModal(order) {
    return {
        type : OPEN_LAB_ORDER_SAMPLING_MODAL,
        open : true,
        order: order
    }
}

function closeLabOrderSamplingModal() {
    return {
        type : OPEN_LAB_ORDER_SAMPLING_MODAL,
        open : false,
        order: {}
    }
}


function openHomeCareOrderSamplingModal(order) {
    return {
        type : OPEN_HOME_CARE_ORDER_SAMPLING_MODAL,
        open : true,
        order: order
    }
}

function closeHomeCareOrderSamplingModal() {
    return {
        type : OPEN_HOME_CARE_ORDER_SAMPLING_MODAL,
        open : false,
        order: {}
    }
}

function openLabOrderGeneralResultModal(order) {
    return {
        type : OPEN_LAB_ORDER_GENERAL_RESULT_MODAL,
        open : true,
        order: order
    }
}

function closeLabOrderGeneralResultModal() {
    return {
        type : OPEN_LAB_ORDER_GENERAL_RESULT_MODAL,
        open : false,
        order: {}
    }
}

function openLabOrderDirectResultModal(order) {
    return {
        type : OPEN_LAB_ORDER_DIRECT_RESULT_MODAL,
        open : true,
        order: order,
        form : {
            to : '',
            by : ''
        }
    }
}

function updateLabOrderDirectResultModal(order,form) {
    return {
        type : OPEN_LAB_ORDER_DIRECT_RESULT_MODAL,
        open : true,
        order: order,
        form : form
    }
}

function closeLabOrderDirectResultModal() {
    return {
        type : OPEN_LAB_ORDER_DIRECT_RESULT_MODAL,
        open : false,
        order: {},
        form : {
            to : '',
            by : ''
        }
    }
}

function openLabOrderLinkResultModal(order) {
    return {
        type : OPEN_LAB_ORDER_LINK_RESULT_MODAL,
        open : true,
        order: order,
        form : {
            links : []
        }
    }
}

function updateLabOrderLinkResultModal(order, form) {
    return {
        type : OPEN_LAB_ORDER_LINK_RESULT_MODAL,
        open : false,
        order: {},
        form : form
    }
}

function closeLabOrderLinkResultModal() {
    return {
        type : OPEN_LAB_ORDER_LINK_RESULT_MODAL,
        open : false,
        order: {},
        form : {
            links : []
        }
    }
}


function openLabOrderFileResultModal(order) {
    return {
        type : OPEN_LAB_ORDER_FILE_RESULT_MODAL,
        open : true,
        order: order
    }
}

function closeLabOrderFileResultModal() {
    return {
        type : OPEN_LAB_ORDER_FILE_RESULT_MODAL,
        open : false,
        order: {}
    }
}



function openLabOrderFinishModal(order) {
    return {
        type : OPEN_LAB_ORDER_FINISH_MODAL,
        open : true,
        order: order
    }
}

function closeLabOrderFinishModal() {
    return {
        type : OPEN_LAB_ORDER_FINISH_MODAL,
        open : false,
        order: {}
    }
}


function openOrderSafeCallModal(order) {
    return {
        type : OPEN_LAB_ORDER_SAFE_CALL_MODAL,
        open : true,
        order: order
    }
}

function closeOrderSafeCallModal() {
    return {
        type : OPEN_LAB_ORDER_SAFE_CALL_MODAL,
        open : false,
        order: {}
    }
}

// Pharmacy Actions

function openPharmacyOrderReadyModal(order) {
    return {
        type : OPEN_PHARMACY_ORDER_READY_MODAL,
        open : true,
        order: order
    }
}

function closePharmacyOrderReadyModal() {
    return {
        type : OPEN_PHARMACY_ORDER_READY_MODAL,
        open : false,
        order: {}
    }
}

function openPharmacyOrderRejectModal(order) {
    return {
        type : OPEN_PHARMACY_ORDER_REJECT_MODAL,
        open : true,
        order: order
    }
}

function closePharmacyOrderRejectModal() {
    return {
        type : OPEN_PHARMACY_ORDER_REJECT_MODAL,
        open : false,
        order: {}
    }
}

function openPharmacyOrderAcceptModal(order,type) {
    return {
        type : OPEN_PHARMACY_ORDER_ACCEPT_MODAL,
        open : true,
        order: order,
        accept_type: type
    }
}

function closePharmacyOrderAcceptModal() {
    return {
        type : OPEN_PHARMACY_ORDER_ACCEPT_MODAL,
        open : false,
        order: {}
    }
}

function openPharmacyOrderPartialModal(order,type) {
    return {
        type : OPEN_PHARMACY_ORDER_PARTIAL_MODAL,
        open : true,
        order: order,
        accept_type: type
    }
}

function closePharmacyOrderPartialModal() {
    return {
        type : OPEN_PHARMACY_ORDER_PARTIAL_MODAL,
        open : false,
        order: {}
    }
}

function openPharmacyOrderGeneralAcceptModal(order) {
    return {
        type : OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL,
        open : true,
        order: order
    }
}

function closePharmacyOrderGeneralAcceptModal() {
    return {
        type : OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL,
        open : false,
        order: {}
    }
}


export {
    OPEN_REJECT_LAB_ORDER_MODAL,
    openRejectLabOrderModal,
    closeRejectLabOrderModal,
    OPEN_ACCEPT_LAB_ORDER_MODAL,
    openAcceptLabOrderModal,
    closeAcceptLabOrderModal,
    OPEN_SHOW_PRESCRIPTION_MODAL,
    openPrescriptionModal,
    closePrescriptionModal,
    OPEN_LAB_ORDER_SAMPLING_MODAL,
    openLabOrderSamplingModal,
    closeLabOrderSamplingModal,
    OPEN_LAB_ORDER_GENERAL_RESULT_MODAL,
    openLabOrderGeneralResultModal,
    closeLabOrderGeneralResultModal,
    OPEN_LAB_ORDER_DIRECT_RESULT_MODAL,
    openLabOrderDirectResultModal,
    updateLabOrderDirectResultModal,
    closeLabOrderDirectResultModal,
    OPEN_LAB_ORDER_LINK_RESULT_MODAL,
    openLabOrderLinkResultModal,
    updateLabOrderLinkResultModal,
    closeLabOrderLinkResultModal, 
    OPEN_LAB_ORDER_FILE_RESULT_MODAL,
    openLabOrderFileResultModal,
    closeLabOrderFileResultModal,
    OPEN_LAB_ORDER_FINISH_MODAL,
    openLabOrderFinishModal,
    closeLabOrderFinishModal,
    OPEN_LAB_ORDER_SAFE_CALL_MODAL,
    openOrderSafeCallModal,
    closeOrderSafeCallModal,
    OPEN_HOME_CARE_ORDER_SAMPLING_MODAL,
    openHomeCareOrderSamplingModal,
    closeHomeCareOrderSamplingModal,
    OPEN_PHARMACY_ORDER_READY_MODAL,
    openPharmacyOrderReadyModal,
    closePharmacyOrderReadyModal,
    OPEN_PHARMACY_ORDER_REJECT_MODAL,
    openPharmacyOrderRejectModal,
    closePharmacyOrderRejectModal,
    OPEN_PHARMACY_ORDER_ACCEPT_MODAL,
    openPharmacyOrderAcceptModal,
    closePharmacyOrderAcceptModal,
    OPEN_PHARMACY_ORDER_PARTIAL_MODAL,
    openPharmacyOrderPartialModal,
    closePharmacyOrderPartialModal,
    OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL,
    openPharmacyOrderGeneralAcceptModal,
    closePharmacyOrderGeneralAcceptModal
}